module.exports = {
  connection_platform: {
    ip_intern: 'whats.medradius.com.br',                              // IP interno de conexão com backend
        ip_extern: 'whats.medradius.com.br',                              // IP externo de conexão com backend
        port_backend_intern: '8080',                              // Porta interna de conexão com backend
        port_backend_extern: '8080',                              // Porta externa de conexão com backend
        ip_apache_view_intern: 'whats.medradius.com.br',                  // IP interno de conexão com o apache para visualização e reprodução de arquivos
        port_apache_view_intern: '8443',                            // Porta interna de conexão com o apache para visualização e reprodução de arquivos
        ip_apache_view_extern: 'whats.medradius.com.br',                  // IP externo de conexão com o apache para visualização e reprodução de arquivos
        port_apache_view_extern: '8443',                            // Porta externa de conexão com o apache para visualização e reprodução de arquivos
        ip_socket_intern: 'whats.medradius.com.br',                       // IP interno de conexão com WebSocket(IMSDN)
        ip_socket_extern: 'whats.medradius.com.br',                       // IP externo de conexão com WebSocket(IMSDN)
        port_socket_intern: '35065',                                 // Porta interna de conexão com WebSocket(IMSDN)
        port_socket_extern: '35065',                              // Porta externa de conexão com WebSocket(IMSDN)
        type_connect: 'https',                                     // Tipo de conexão com ou sem certificado
        type_socket: 'wss',
        port_node: '443',
        version_ns_old:'3.0.21026.151',
        version_ns:'3.4.21042.151',
        azure_auth: false,
        nc2_integration: false,
        nc2_users: [],
        nc2_url: '',
        time_alert_pause: 5000,
        client_differentip: false,
        client_webrtc: true,
        url_ingdesk: '',
        isOrganization: false,
        backendCentralExtern: '',
        backendCentralIntern: '',
        backendCentralExternPort: '',
        backendCentralInternPort: '',
        url_ingceub: '',
        url_crm: '',
        isLinkDinamyc: false,
        url_mail: '',
        isExistMail: false,
        manager_screen_new: true,
        manager_screen_old: false,
        play_callin: '',
        // play_callin: '/sound/sussurro.mp3',
        remove_digits: false,
        multitenancy: false,
        class_image_login: "col-login bg-login",
        //class_image_login:'col-smarters bg-login',
        client_personalized: 0, // 0 => padrao | 1 => smarters
        attendance_screen_new: true,
        maps_apiKey: "AIzaSyCL1Hblm1iexrA-VH-ULi3eAXZ8Otb67VY",
        screngroupmonitoring: true,
        audiofila:
          "https://whats.medradius.com.br:8443/ingweb/frontend/build/sound/chamada_fila.mp3",
        buttonface: false,
        milliseconds: 10000,
        timeCampaigns: 300000, //tempo em milisegundos
        // timeExceedAtend: 120000, //tempo em milisegundos
        seeCampaigns: false,
        showTimeMedDashboard: true,
        companyLogoUrl: "",
        ingDeskBaseUrl: "",
        alertimsdnout: true,
        exibSearchDash: true,
        buttoninstagram: false,
        port_http_voz: 8040,
        visibleCallCenter: false,
        changeRowQueueDashboard: false,
        isStatusOfErrorInSendMessage: true, //padrão é true, permite o simbolo de erro ao enviar uma mensagem sem antes enviar um hsm
        delayTableOperators: 500, // Delay da tabela do dashboard para casos onde tem muito usuario, padrão 500, em outros casos como sotreq 5000
        azureconfiguration: {},
        insertWithCompany: false,
        analyticalViewsAllowed: [1, 2, 3, 4],
        isServiceTabActive: true,
        allowSendingMultipleItemInCampaing: true,
        isToActiveClientWallet: true,
        waitToSendReq: {
          isToActive: false, //quando true vai desabilitar o envio do REQ durante um determinado tempo no início do login
          isToDisableReqOnChangeAtd: false, //quando true vai desabilitar o envio do REQ ao trocar de atendimento
          timeToWait: 30000, //tempo que vai demorar após o login para enviar o req
        },
        isToAvoidSendInsertpausaslvTwice: true, //evitar chamar /insertpausaslv duas vezes seguidas
        voiceServiceActive: true, //tentativa de tratamento da parte de voz
        isToShowModalInHistoric: false,
  },
};
